import {publishOpenCopilotChat} from '@github-ui/copilot-chat/utils/copilot-chat-events'
import {CopilotChatIntents, type FileDiffReference} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {copilotFeatureFlags} from '@github-ui/copilot-chat/utils/copilot-feature-flags'
import {copilotLocalStorage} from '@github-ui/copilot-chat/utils/copilot-local-storage'
import {sendEvent} from '@github-ui/hydro-analytics'
import {ActionList} from '@primer/react'
import type {ReactElement} from 'react'

export interface DiffLinesDiscussMenuItemProps {
  fileDiffReference: FileDiffReference
  leadingVisual?: ReactElement
  eventContext?: Parameters<typeof sendEvent>[1]
  afterSelect?: () => void
}

export const DiffLinesDiscussMenuItem: React.FC<DiffLinesDiscussMenuItemProps> = ({
  fileDiffReference,
  leadingVisual,
  eventContext,
  afterSelect,
}) => {
  const handleDiscuss = () => {
    if (copilotFeatureFlags.copilotRedirectDiffViewToImmersive) {
      sendEvent('copilot.file-diff.discuss', {target: 'file-diff', mode: 'immersive'})
      copilotLocalStorage.setCurrentReferences(null, [fileDiffReference])
      copilotLocalStorage.setCopilotDiffReferences(fileDiffReference)
      window.location.href = '/copilot'
    } else {
      sendEvent('copilot.file-diff.discuss', {
        target: 'file-diff',
        mode: 'assistive',
        ...eventContext,
      })
      publishOpenCopilotChat({
        intent: CopilotChatIntents.conversation,
        references: [fileDiffReference],
      })
      afterSelect?.()
    }
  }

  return (
    <ActionList.Item onSelect={handleDiscuss}>
      {leadingVisual && <ActionList.LeadingVisual>{leadingVisual}</ActionList.LeadingVisual>}
      Ask about this diff
    </ActionList.Item>
  )
}

try{ DiffLinesDiscussMenuItem.displayName ||= 'DiffLinesDiscussMenuItem' } catch {}